// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"style_breadcrumbs__XQPS9","link":"style_link__w4A-C"};